import { Container, Sprite, Texture, Rectangle } from 'pixi.js';
import { Tween, Easing } from '@tweenjs/tween.js';
import { EVENTS } from '../lib/constants';
import HELPERS from '../lib/globals/helpers/Helpers';
import { GameConfigs } from '../lib/globals/GameConfigs';
import { isDesktop } from 'react-device-detect';
// import Trigger from './Trigger';

class AnimatedIcon extends Container {
	item = null;
	bg = null;
	fg = null;
	fg2 = null;
	ring = null;
	fgmask = null;
	frameTween = null;
	reel_position = null;
	// isAnimated = true;
	constructor(item, isBlur, first, isBait, pos) {
		super();
		this.reel_position = pos;
		this.item = item;
		this.sprites = [];
		window.addEventListener(
			EVENTS.SETTINGS_UPDATE,
			this.settingsChanged.bind(this),
			false
		);

		if (isBlur || isBait) {
			this.bg = Sprite.from(Texture.from(item.iconBg));
			this.bg.x = -(this.bg.width / 2 - this.item.width / 2);
			this.bg.y = -(this.bg.height / 2 - this.item.height / 2);
			this.bg.alpha = 0.4;
			this.addChild(this.bg);
			this.fg = Sprite.from(Texture.from(item.iconBlurred));
			this.addChild(this.fg);
		} else {
			if (this.item.animation.bg !== undefined) {
				this.bg = HELPERS.getAnimatedSprite(this.item.animation.bg);
				if (!this.item.isSticked) {
				}
				this.addChild(this.bg);
				this.sprites.push(this.bg);
				if (this.item.animation.bg.offsetX) {
					this.bg.x = this.item.animation.bg.offsetX;
				}
				if (this.item.animation.bg.offsetY) {
					this.bg.y = this.item.animation.bg.offsetY;
				}
				if (this.item.animation.bg.scale) {
					this.bg.scale.set(
						this.item.animation.bg.scale.x,
						this.item.animation.bg.scale.y
					);
				}
				if (this.item.isSticked) {
					if (GameConfigs.settings.game_animation) {
						this.bg.gotoAndPlay(0);
					} else {
						this.bg.gotoAndStop(0);
					}
				} /**/
			} else {
				this.bg = Sprite.from(Texture.from(item.iconBg));
				this.bg.anchor.set(0.5, 0.5);
				this.bg.x = this.item.width / 2;
				this.bg.y = this.item.height / 2 - 10;
				this.bg.alpha = first ? 1 : 0;
				this.bg.scale.set(0.95);
				this.addChild(this.bg);
			}

			if (this.item.animation.frame) {
				this.frame = HELPERS.getAnimatedSprite(this.item.animation.frame);
				if (!this.item.isSticked) {
				}
				this.addChild(this.frame);
				this.sprites.push(this.frame);
				// this.frame.anchor.set(0.5, 0.5);
				// this.frame.position.set(this.item.width / 2, this.item.height / 2);
				//this.frame.position.set(-16, -20);
				//this.frame.scale.set(1.03, 1.03);
				//this.addChild(this.frame);
				this.frame.alpha = 0;
				if (this.item.animation.frame.scale !== undefined) {
					this.frame.scale.set(
						this.item.animation.frame.scale.x,
						this.item.animation.frame.scale.y
					);
				}
				if (this.item.animation.frame.offsetX) {
					this.frame.position.x = this.item.animation.frame.offsetX;
				}
				if (this.item.animation.frame.offsetY) {
					this.frame.position.y = this.item.animation.frame.offsetY;
				}
			}

			if (this.item.animation.fog) {
				this.fog = HELPERS.getAnimatedSprite(this.item.animation.fog);
				this.addChild(this.fog);
				// this.sprites.push(this.fog);
				this.fog.anchor.set(0.5, 0.5);
				this.fog.x = this.item.width / 2;
				this.fog.y = this.item.height / 2 - 10;
				// this.fog.scale.set(0.95);
				this.fog.gotoAndPlay(0);
			}
			if (this.item.animation.fg !== undefined) {
				this.fg = HELPERS.getAnimatedSprite(this.item.animation.fg);
				this.addChild(this.fg);
				this.sprites.push(this.fg);
				// this.fg.scale.set(1.05, 1.05);
				if (this.item.animation.fg.scale) {
					this.fg.scale.set(
						(this.item.animation.fg.scale.x, this.item.animation.fg.scale.y)
					);
				}
				// this.fg.scale.set(0.9);
				if (item.fgmask) {
					this.fgmask = Sprite.from(Texture.from(item.fgmask));
					this.fg.addChild(this.fgmask);
					this.fg.mask = this.fgmask;
				}
				if (isDesktop) {
					this.fg.x = -5;
					this.fg.y = -10;
				} else {
					this.fg.x = -5 / 2;
					this.fg.y = -10 / 2;
				}

				if (this.item.animation.fg.offsetX !== undefined) {
					this.fg.x = this.item.animation.fg.offsetX;
				}
				if (this.item.animation.fg.offsetY !== undefined) {
					this.fg.y = this.item.animation.fg.offsetY;
				}
			}
			// if (this.item.id === 5) {
			// 	this.trigger = new Trigger(this.bg);
			// 	if (GameConfigs.uiComponent) {
			// 		GameConfigs.uiComponent.addChildAt(this.trigger, 0);
			// 	}
			// }

			if (this.item.animation.fg2Index >= 0) {
				let data = this.item.animation.fg2Data[this.item.animation.fg2Index];
				if (data.pattern !== undefined) {
					this.fg2 = HELPERS.getAnimatedSprite(data);
					this.addChild(this.fg2);
					this.sprites.push(this.fg2);

					if (data.offsetX !== undefined) {
						this.fg2.x = data.offsetX;
					}
					if (data.offsetY !== undefined) {
						this.fg2.y = data.offsetY;
					}
				} else {
					this.fg2 = new this.item.Fg2Class(data);
					if (data.offsetX !== undefined) {
						this.fg2.x = data.offsetX;
					}
					if (data.offsetY !== undefined) {
						this.fg2.y = data.offsetY;
					}
					if (data.scale !== undefined) {
						this.fg2.scale.x = data.scale.x;
						this.fg2.scale.y = data.scale.y;
					}
					this.addChild(this.fg2);
				}
			}

			if (this.item.id === 12) {
				this.fg.gotoAndPlay(0);
			}
			this.interactive = true;
			this.cursor = 'pointer';
			this.on(
				window.isMobile || window.isTablet ? 'tap' : 'click',
				this.clickHandler.bind(this)
			);
			if (window.isMobile) {
				this.hitArea = new Rectangle(5, 5, 113 - 10, 114 - 10);
			} else {
				this.hitArea = new Rectangle(10, 10, 226, 228);
			}
		}
	}

	clickHandler(evt) {
		HELPERS.dispatchCustomEvent(EVENTS.ICON_CLICKED, {
			id: this.item.id,
			reel_position: this.reel_position,
			icon: this
		});
	}

	settingsChanged(e) {
		for (var i = 0; i < this.sprites.length; i++) {
			if (e.detail.game_animation === undefined) return;
			if (!e.detail.data.game_animation) {
				this.sprites[i].gotoAndStop(0);
			}
		}
	}
	disable() {
		if (this.frameTween) {
			this.frameTween.stop();
		}
		if (!this.item.isSticked) {
			if (this.frame) {
				this.frameTween = new Tween(this.frame)
					.to({ alpha: 0 }, 50)
					.easing(Easing.Linear.None)
					.start();
			}
		}

		if (!this.item.isSticked) {
			this.alpha = 0.3;
		}

		//this.alpha = 0.6
	}

	animateLoop() {
		this.animate();
	}

	stopLoop() {
		this.disable();
		this.alpha = 1;
	}

	enable() {
		this.alpha = 1;
	}

	showBG(delay, time, alp) {
		new Tween(this.bg)
			.to({ alpha: alp }, time)
			.delay(delay)
			.easing(Easing.Linear.None)
			.start();
	}
	animateFrame(frame) {
		this.frame.gotoAndPlay(frame);
		this.frameTween = new Tween(this.frame)
			.to({ alpha: 1 }, 250)
			.easing(Easing.Linear.None)
			.start();
	}
	animate() {
		if (GameConfigs.settings.game_animation) {
			if (this.frameTween) {
				this.frameTween.stop();
			}
			if (this.item.animation.bg !== undefined) {
				this.bg.gotoAndPlay(0);
			}
			if (this.item.animation.fg !== undefined) {
				this.fg.gotoAndPlay(0);
			}
			if (this.item.animation.fg2Index >= 0) {
				if (this.fg2.gotoAndPlay) {
					this.fg2.gotoAndPlay(0);
				} else if (this.fg2.animate) {
					this.fg2.animate();
				}
			}
			if (this.item.animation.frame !== undefined) {
				if (!this.item.isSticked) {
					this.frame.gotoAndPlay(0);
					this.frameTween = new Tween(this.frame)
						.to({ alpha: 1 }, 250)
						.easing(Easing.Linear.None)
						.start();
				}
			}
		} else {
			if (this.item.animation.frame !== undefined) {
				if (this.frame) {
					this.frame.gotoAndStop(0);
					this.frameTween = new Tween(this.frame)
						.to({ alpha: 1 }, 250)
						.easing(Easing.Linear.None)
						.start();
					if (!this.item.isSticked) {
						this.frame.gotoAndStop(0);
					}
				}
			}
		}
	}
}

export default AnimatedIcon;
